module.exports = __webpack_public_path__ + "img/pay-success.cd200b0a.gif";